<app-dialog
  [headerLabel]="headerLabel"
  [dialogType]="dialogType"
  [primaryActionText]="confirmLabel"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  (onPrimaryAction)="onPrimaryAction()"
  (onDialogClose)="onCancel.emit()"
>
  <div id="payments-info-dialog">
    <p class="intro" [innerHTML]="introLabel | safe: 'html'"></p>

    <p *ngIf="description" class="description">
      {{ description }}
    </p>

    <span class="how-it-works">
      <strong>{{ 'DIALOG.PAYMENTS.LABEL.HOW_IT_WORKS' | translate }}</strong>
    </span>

    <ol class="how-it-works-list">
      <li *ngFor="let listItem of listItems" class="how-it-works-list-item">
        {{ listItem }}
      </li>
    </ol>
  </div>
</app-dialog>
